export const TRANSLATIONS: Object = {
  'global#no_connection': 'No connection to the server, it is impossible to complete the operation',
  'global#disconneced': 'Disconnected',
  'global#lost_focus': 'You lost focus . Click here to go back to the questionnaire',
  'global#lang_en': 'English',
  'global#lang_it': 'Italiano',
  'global#born': 'Born on',
  'global#in': 'in',
  'global#feedback': 'Leave an opinion',
  'global#results': 'Results',
  'global#end': 'Finish',
  'global#total_questions': 'Questions',
  'global#right_answers': 'Correct answers',
  'global#wrong_answers': 'Wrong answers',
  'global#null_answers': 'Unanswered questions',
  'global#section_points': 'Section score',

  'login#email_label': 'Login',
  'login#email_placeholder': 'Enter your username',
  'login#password_label': 'Password',
  'login#password_placeholder': 'Enter your password',
  'login#confirm': 'Login',
  'login#title': 'Log in test CISIA',
  'login#sub_title': 'Enter your credentials to proceed',
  'login#full_screen_exit': 'The operation was interrupted',
  'login#connection_error_line0': 'It was not possible to connect to the server.',
  'login#connection_error_line1': 'Please try again in a few minutes.',
  'login#timeout': 'Timeout',
  'login#show_password': 'show password',
  'login#hide_password': 'hide password',

  'modal#confirm_label': 'I confirm:',
  'modal#insert_code_label': 'Enter the code:',
  'modal#no_connection': 'There is no connection to the server at the moment.',
  'modal#termiate_title': 'Time expired',
  'modal#termiate_description': 'You can continue with section',
  'modal#termiate_submit': 'Continue',
  'modal#terminate_request_title': 'The time at your disposal is over',
  'modal#terminate_request_description': 'The test is finished, continue to save and view the result',
  'modal#terminate_request_submit': 'Save',
  'modal#terminate_request_check': 'I will see the final result',
  'modal#terminate_request_user_title': 'Please note, procedure to finish the test',
  'modal#terminate_request_user_submit': 'Finish',
  'modal#terminate_request_user_check_1': 'I want to conclude the test',
  'modal#terminate_request_user_check_2': 'I will see the final result',
  'modal#change_section_title': 'Do you want to continue to section',
  'modal#change_section_submit': 'Continue',
  'modal#change_section_description_1': 'By continuing to section',
  'modal#change_section_description_2': 'you will not be able to come back to this section',
  'modal#change_section_description_3': 'and you will lose unused time.',
  'modal#change_section_freeInsert': '[en]',
  'modal#change_section_check_1': 'I want to continue to section',
  'modal#change_section_check_2': 'I will lose unused time',
  'modal#insert_code': 'Enter the code',
  'modal#cancel': 'Cancel',
  'modal#confirm': 'Confirm',
  'modal#refresh_title': 'Please wait',
  'modal#refresh_description': 'Loading...',
  'modal#local_id': 'Local ID',
  'modal#local_ip': 'Local IP',
  'modal#sync_status_pending': 'Salvataggio sezione in corso',
  'modal#sync_status_ko': 'Salvataggio sezione non riuscito',
  'modal#confirm_audio_start_title': 'Audio playback start',
  'modal#confirm_audio_start_description': 'We remind you that playback can\'t be stopped once started.<br />Do you confirm audio playback start?',

  'title#test_evaluation': 'Test evaluation',
  'title#answer_correct': 'Correct answer',
  'title#answer_wrong': 'Wrong answer',
  'title#answer_null': 'Null answer',

  'console#title': 'Verification console',
  'console#close': 'Close',
  'console#server_ok': 'Connected to the server',
  'console#internet_ok': 'Internet access blocked ',
  'console#canvas_ok': 'Canvas support',
  'console#html5_ok': 'HTML5 support',
  'console#audio_ok': 'Audio support',
  'console#storage_ok': 'Local memory support',
  'console#websockets_ok': 'Web socket support',
  'console#ping_cisia_ok': 'Ping server CISIA',
  'console#speed_test': 'Speed test',
  'console#send_log': 'Send error report',
  'console#duplicate_login_title': 'Warning!',
  'console#duplicate_login_description': '<div class="modal-message-center">Simultaneous access detected, <br />you won\'t be able to proceed with test in this window<br />Please alert the examination body.</div>',

  'wait#welcome_greetings_line_2a': 'Please check the accuracy of the above personal information,\n',
  'wait#welcome_greetings_line_2b': 'and if it is not correct inform the exam commission.',
  'wait#welcome_greetings_line_2c': 'To begin the test press "Begin".',
  'wait#welcome_greetings_line_tr_2a': 'In few seconds you will be able to start the test.',
  'wait#welcome_greetings_line_2a_res': 'The last successful file save was recovered.',
  'wait#welcome_greetings_line_2_res': 'To continue the test press "Resume"',
  'wait#welcome_greetings_line_2_ris': 'to view the results press "Results"',
  'wait#welcome_greetings_submit': 'Begin',
  'wait#welcome_greetings_submit_res': 'Resume',
  'wait#welcome_greetings_submit_ris': 'Results',
  'wait#welcome_greetings_submit_section_loading': 'Loading test...',
  'wait#welcome_greetings_name': 'Name',
  'wait#welcome_greetings_birthday': 'Date of birth',
  'wait#welcome_greetings_birth_place': 'Place of birth',
  'wait#welcome_greetings_cod_fisc': 'Fis. code',
  'wait#welcome_line_1': 'Start the application and do not exit fullscreen',
  'wait#welcome_line_2': 'after logging in',
  'wait#welcome_submit': 'Start',
  'wait#nb_intro': 'Please note:',
  'wait#nb_description': 'Pressing \'esc\' will block the test',
  'wait#restore_test_line_1': 'You have',
  'wait#restore_test_line_2': 'seconds to resume the test',
  'wait#restore_test_without_count': 'Return immediately to fullscreen, time is running',
  'wait#restore_submit': 'Return to fullscreen',
  'wait#test_locked': 'Test blocked: inform the person responsible in the test room',
  'wait#test_section_error': 'Attenzione è stato rilevato un problema bloccante, non è stato possibile caricare la sezione successiva, segnali il problema al commissario d\'aula.',
  'wait#back_to_login': 'Return to log in',
  'wait#socket_disconnected': 'Server is disconnected',

  'survey#domanda': 'Question',
  'survey#domande': 'Questions',
  'survey#domanda_wrong': '(wrong)',
  'survey#domanda_empty': '(invalid)',
  'survey#testo_comprensione': 'Comprehension test',
  'survey#timer_label': 'Remaining time',
  'survey#wrong_code_on_terminate': 'Wrong code',
  'survey#select_answer': 'Choose an answer',
  'survey#deselect_answer': 'No answer',

  'report#back_to_survey_1': 'Click here to see the questions',
  'report#back_to_survey_2': ' you haven\'t answered or to which you answered incorrectly',
  'report#point_label': 'Total score: ',

  'help#attenzione': 'Please note',
  'help#box_orange_line_0': 'While viewing this help the timer will',
  'help#box_orange_line_1': 'NOT',
  'help#box_orange_line_2': 'be put in pause to finish this section',
  'help#box_parag_0': 'During the test, inside one section, you can scroll up and down the questions to check again your answers. To cancel an answer just press on the answer you want to cancel.',
  'help#box_parag_1_line_0': 'You can at any time press the button',
  'help#box_parag_1_line_1': '"Finish"',
  'help#box_parag_1_line_2': ' and by pressing it you will interrupt the test and continue to the results page. The test will also be automatically interrupted at the end of the time assigned.',
  'help#box_parag_2': 'When continuing to another section it will not be possible to return to the previous section.',
  'help#valutazione': 'Evaluation',
  'help#box_parag_3_line_0': 'The result of the TOLC is calculated by assigning 1 point for each correct answer, 0 points for each unanswered question and a penalty of 0.25 points for each incorrect answer. ',
  'help#box_parag_3_line_1': 'In the evaluation of the English language there is no penalty for incorrect answers and the score is calculated by assigning 1 point for each correct answer and 0 points for each unanswered question or incorrect answers.',
  'help#sezioni': 'Sections',
  'help#image_0': 'Indicates the section currently viewed',
  'help#image_1': 'Indicates the next section',
  'help#image_2': 'Indicates a section not selectable',
  'help#quesiti': 'Questions',
  'help#image_3': 'Indicates the question currently viewed',
  'help#image_4': 'Indicates a question already answered',
  'help#image_5': 'Indicates a question still unanswered',
  'help#image_6': 'Indicates a page with text',
  'help#image_7': 'Arrows to move to the previous or next question',
  'help#altri_strumenti': 'Other instruments',
  'help#altri_strumenti_button_0': 'This button will interrupt the test and proceed to the results page.',
  'help#altri_strumenti_button_1': 'View this page',
  'help#box_parag_4': 'To modify the zoom level of the page use the command keys (CTRL or CMD) together with the + key or - key respectively to increase or decrease the zoom level.',
  'help#timer_image': 'The timer indicates the remaining minutes and seconds for the current section.',
  'help#audio_player': 'The audiotrack is launched by pressing the “play” button and you can turn the volume up or down, using the button on the side. Once the audiotrack has been launched, it is not possible to stop it: you must listen to it to the end.'
};



// WEBPACK FOOTER //
// ./src/app/constants/translations/en.ts